import React from 'react'
import maestroLogo from '../assets/images/MAESTRO_300x60.png'

const MaestroLogo = ({ className = '' }) => {
  return (
    <img
      className={`${className}`}
      src={maestroLogo}
      alt='maestro_logo'
    />
  )
}

export default MaestroLogo